<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Reportes</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
  </v-toolbar>
  <v-card>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex d-flex>
            <v-menu
              ref="menuFechaInicio"
              :close-on-content-click="false"
              v-model="menuFechaInicio"
              :nudge-right="40"
              :return-value.sync="registro.fechaInicio"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fechaInicio"
                label="Fecha"
                prepend-icon="event"
                @blur="registro.fechaInicio = parseDate(fechaInicio)"
                readonly
              ></v-text-field>
              <v-date-picker v-model="registro.fechaInicio" locale='es-pe' @input="$refs.menuFechaInicio.save(registro.fechaInicio)" v-bind:readonly="disabledRegistro" scrollable></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex d-flex>
            <v-menu
              ref="menuFechaFin"
              :close-on-content-click="false"
              v-model="menuFechaFin"
              :nudge-right="40"
              :return-value.sync="registro.fechaFin"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fechaFin"
                label="Fecha"
                prepend-icon="event"
                @blur="registro.fechaFin = parseDate(fechaFin)"
                readonly
              ></v-text-field>
              <v-date-picker v-model="registro.fechaFin" locale='es-pe' @input="$refs.menuFechaFin.save(registro.fechaFin)" v-bind:readonly="disabledRegistro" scrollable></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex d-flex>
            <v-select
               v-bind:readonly="disabledRegistro"
              :items="reportes"
              item-text="value"
              item-value="id"
              label="Tipo de reporte"
              v-model="registro.tipoReporte"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click.native="generar" v-if="!disabledRegistro">Generar</v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menuFechaInicio: false,
    menuFechaFin: false,
    fechaInicio: null,
    fechaFin: null,
    datos: [],
    reportes: [
      { id: 'C', value: 'Comprobantes' }
    ],
    registro: {}
  }),
  computed: {
    computedFechaInicio () {
      return this.formatoFecha(this.registro.fechaInicio)
    },
    computedFechaFin () {
      return this.formatoFecha(this.registro.fechaFin)
    }
  },
  watch: {
    'registro.fechaInicio' (val) {
      this.fechaInicio = this.formatoFecha(this.registro.fechaInicio)
    },
    'registro.fechaFin' (val) {
      this.fechaFin = this.formatoFecha(this.registro.fechaFin)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    this.pagination.rowsPerPage = 10
    this.nuevoRegistro()
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.NODE_API}ventasReportes/ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            if (item.id !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({id: 0})
    },
    generar () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}ventasReportes/imprimir`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.d.tipo === 'xlsx') {
            var link = document.createElement('a')
            link.href = 'data:application/xlsx;base64,' + datos.d.data
            link.download = datos.d.nombre
            link.click()
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ReporteVentas.vue